import Vue from "vue";
import Vuex from "vuex";

import loader from "./modules/loader";
import dialogSaveAndExit from "./modules/dialogSaveAndExit";
import booking from "./modules/booking";
import cabinConfiguration from "./modules/cabinConfiguration";
import contact from "./modules/contact";
import contactBooking from "./modules/contactBooking";
import preArrangement from "./modules/preArrangement";
import postArrangement from "./modules/postArrangement";
import visaRequirement from "./modules/visaRequirement";
import passport from "./modules/passport";
import common from "./modules/common";

import createLogger from "../plugins/logger";

Vue.use(Vuex);

const debug = process.env.debug === "true";

const store = new Vuex.Store({
  modules: {
    loader,
    dialogSaveAndExit,
    booking,
    cabinConfiguration,
    contact,
    contactBooking,
    preArrangement,
    postArrangement,
    visaRequirement,
    passport,
    common,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js